import Text from 'antd/lib/typography/Text'
import { Flex } from 'antd'

import { Ticket, StatusTicketEnum } from '@types'
import { useUser } from '@contexts'
import { ImplementationTimeUtils } from '@utils'

import { useHandleTicketModal } from '../../../../../../../contexts/HandleTicketModalContext'
import { CardRow, StyledRequestCard } from '../../..'
import CardIndicator from '../CardIndicator'

interface RequestCardProps {
  data: Ticket
}

const { formatInCompanyZone } = ImplementationTimeUtils

const RequestCard = (props: RequestCardProps) => {
  const { data } = props
  const { CANCELED, NO_SHOW } = StatusTicketEnum
  const { setTicketToEdit, setIsTicketModalOpen } = useHandleTicketModal()
  const { state: user } = useUser()
  const withdrawalTimeLabel = formatInCompanyZone(data.withdrawalDate, user?.company?.gmtZone ?? 0)

  //TODO: Commit destacar asignación manual

  return (
    <StyledRequestCard
      onClick={e => {
        const { tagName } = e.target as HTMLInputElement
        if (tagName !== 'INPUT') {
          setTicketToEdit(data.id)
          setIsTicketModalOpen(true)
        }
      }}
      style={{ backgroundColor: `#${data.equipment?.color}` }}
      className={`${data.status.name === CANCELED && 'canceled'} ${
        data.status.name === NO_SHOW && 'no-show'
      }`}
    >
      <CardRow className="card__header">
        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
          <Flex align="center" gap={4}>
            <Text className="card__withdrawal-info" style={{ whiteSpace: 'nowrap' }}>
              {`${withdrawalTimeLabel} | #${data.id}`}
            </Text>
            {!data.autoAssign && <span style={{ fontSize: '16px' }}>✋</span>}
          </Flex>
          <CardIndicator
            dateCreated={data.createAt}
            status={data.status.name}
            date={data.pendingDate || undefined}
            withdrawalDate={data.withdrawalDate}
          />
        </Flex>
      </CardRow>
      <CardRow className="card__content">
        <Flex vertical className="item">
          <Text>De:</Text>
        </Flex>
        <Flex>{data.origin?.tag && <Text>{data.origin.tag}</Text>}</Flex>
      </CardRow>
      <CardRow className="card__content">
        <Flex vertical className="item">
          <Text>A:</Text>
        </Flex>
        <Flex>{data.destination?.tag && <Text>{data.destination.tag}</Text>}</Flex>
      </CardRow>
      {data.material?.nameShort && (
        <CardRow className="card__content">
          <Text className="scrap-green">Mat: {data.material.nameShort}</Text>
        </CardRow>
      )}
      {data.equipment?.nameShort && (
        <CardRow className="card__content">
          <Text>
            Eq: {data.carrier && <u>&ldquo;{data.carrier.businessName}&ldquo;</u>}{' '}
            {data.equipment.nameShort}
          </Text>
        </CardRow>
      )}
    </StyledRequestCard>
  )
}

export default RequestCard

//TODO: Here is the onClick to open tickets for lines 22 to 28
